var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Kevin Nguyen <kevin@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext } from "react";
import { Box } from "@mui/system";
import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Typography } from "@mui/material";
import { Header, HeaderErrorVariant } from "@sequentech/ui-essentials";
import styled from "@emotion/styled";
import { useRootBackLink } from "../hooks/root-back-link";
import { VotingPortalError, VotingPortalErrorType } from "../services/VotingPortalError";
import { SettingsContext } from "../providers/SettingsContextProvider";
import { AuthContext } from "../providers/AuthContextProvider";
var StyledLink = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    text-decoration: none;\n    margin-top: 40px;\n"], ["\n    text-decoration: none;\n    margin-top: 40px;\n"])));
var StyledTitle = styled(Typography)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    font-size: 36px;\n    justify-content: center;\n"], ["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    font-size: 36px;\n    justify-content: center;\n"])));
export function ErrorPage() {
    var _a;
    var error = useRouteError();
    var t = useTranslation().t;
    var backLink = useRootBackLink();
    var globalSettings = useContext(SettingsContext).globalSettings;
    var authContext = useContext(AuthContext);
    var isErrorType = error instanceof Error || error instanceof VotingPortalError;
    var content = (_jsxs(_Fragment, { children: [_jsx(StyledTitle, __assign({ variant: "h3", sx: { marginBottom: "24px" } }, { children: t("errors.page.oopsWithoutStatus") })), _jsx(Typography, __assign({ variant: "h6", sx: { marginBottom: "24px" } }, { children: t("errors.page.somethingWrong") }))] }));
    if (isRouteErrorResponse(error)) {
        content = (_jsxs(_Fragment, { children: [_jsx(StyledTitle, __assign({ variant: "h3", sx: { marginBottom: "24px" } }, { children: t("errors.page.oopsWithStatus", { status: error.status }) })), _jsx(Typography, __assign({ variant: "h6", sx: { marginBottom: "24px" } }, { children: error.statusText })), ((_a = error.data) === null || _a === void 0 ? void 0 : _a.message) && (_jsx(Typography, { children: _jsx("i", { children: error.data.message }) }))] }));
    }
    else if (isErrorType) {
        content = (_jsxs(_Fragment, { children: [_jsx(StyledTitle, __assign({ variant: "h3", sx: { marginBottom: "24px" } }, { children: t("errors.page.oopsWithoutStatus") })), _jsx(Typography, __assign({ variant: "h6", sx: { marginBottom: "24px" } }, { children: t("errors.page.somethingWrong") })), _jsx(Typography, { children: _jsx("i", { children: error.message }) })] }));
    }
    return (_jsxs(Box, __assign({ sx: { minHeight: "100vh" }, className: "error-screen screen" }, { children: [_jsx(Header, { appVersion: { main: globalSettings.APP_VERSION }, errorVariant: HeaderErrorVariant.HIDE_PROFILE, logoutFn: authContext.isAuthenticated ? authContext.logout : undefined }), _jsxs(Box, __assign({ id: "error-page", sx: {
                    width: "100%",
                    height: "50vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                } }, { children: [content, !(error instanceof VotingPortalError &&
                        error.type === VotingPortalErrorType.NO_ELECTION_EVENT) && (_jsx(StyledLink, __assign({ to: backLink }, { children: _jsx(Button, __assign({ sx: { textDecoration: "none" } }, { children: t("common.goBack") })) })))] }))] })));
}
var templateObject_1, templateObject_2;
